export const getPercentComplete = (progress: number | undefined, overall: number | undefined) => {
  if (progress === undefined || overall === undefined) return ''

  return Math.round((progress / overall) * 100)
}
